import AkOrganisations from './dynamicComponents/AkOrganisations'
import AkScholarships from './dynamicComponents/AkScholarships'
import SchNetPrograms from './dynamicComponents/SchNetPrograms'

const components = {
  AkScholarships: AkScholarships,
  AkOrganisations: AkOrganisations,
  SchNetPrograms: SchNetPrograms,
}

const componentForName = ( name ) => {

  let component = components[name]

  if ( !component ) {
    console.warn("no component found: ", name)
  }

  return component
}

export {
  components,
  componentForName
}
